import { user } from '../../utils';
import { OfferCreatedEvent } from '../../Shared/events';
import { OfferCreatedBIModel } from '../models';
import { track } from '../../tracking/bi-track';

export const offerCreatedBIEventListener = () => {
    document.addEventListener(OfferCreatedEvent.eventType, (offerCreatedEvent) => {
        const offerCreatedBIModel = OfferCreatedBIModel.createFromDomainEvent(user.id, offerCreatedEvent);
        track(offerCreatedBIModel);
    });
};
